import { useI18n } from 'vue-i18n'

export const useTime = () => {
    const { t: $t } = useI18n({
        useScope: 'global',
    })

    const formatDelta = (delta?: number) => {
        if (!delta)
            return {
                value: 0,
                unit: $t('time.unit.second', 0),
            }
        const seconds = Math.floor(delta / 1000)
        const minutes = Math.floor(delta / (1000 * 60))
        const hours = Math.floor(delta / (1000 * 60 * 60))
        const days = Math.floor(delta / (1000 * 60 * 60 * 24))

        if (seconds < 60) {
            return {
                value: seconds,
                unit: $t('time.unit.second', seconds),
            }
        }

        if (minutes < 60) {
            return {
                value: minutes,
                unit: $t('time.unit.minute', minutes),
            }
        }

        if (hours < 24) {
            return {
                value: hours,
                unit: $t('time.unit.hour', hours),
            }
        }

        return {
            value: days,
            unit: $t('time.unit.day', days),
        }
    }

    const formatDeltaToString = (delta?: number) => {
        const { value, unit } = formatDelta(delta)
        return `${value} ${unit}`
    }

    return {
        formatDelta,
        formatDeltaToString,
    }
}
